/**
 * メール本文がHTMLコンテンツかどうかを判定する
 * @param {string} content メール本文テキスト
 * @return {boolean} HTMLコンテンツの場合true
 */
export function isHtmlContent(content: string): boolean {
  if (!content) return false;
  return /<(?:html|head|body|div|table|p|br|span|a|img|style|!doctype)\b/i.test(
    content,
  );
}

/**
 * HTMLコンテンツ内のテキスト部分にハイライト用markタグを挿入する
 * HTMLタグ内の属性値はハイライト対象外とし、テキストノードのみを対象とする
 * @param {string} html HTMLコンテンツ
 * @param {string[]} words ハイライト対象のキーワード配列
 * @return {string} ハイライト用markタグが挿入されたHTML
 */
export function highlightHtmlContent(html: string, words: string[]): string {
  if (!html || words.length === 0) return html;

  const escapedWords = words
    .filter(w => w.length > 0)
    .map(w => w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  if (escapedWords.length === 0) return html;

  const wordPattern = new RegExp(`(${escapedWords.join("|")})`, "gi");

  // HTMLをタグ部分とテキスト部分に分割し、テキスト部分のみにmarkタグを挿入
  return html.replace(/(<[^>]*>)|([^<]+)/g, (_match, tag, text) => {
    if (tag) return tag;
    return text.replace(
      wordPattern,
      '<mark style="background-color:yellow;font-weight:bold">$1</mark>',
    );
  });
}
